import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root"
})
export class UsuarioService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public postUsuario(params): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_USUARIO;
    return this.http.post<any>(url, params).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Usuario",
            text: "Verifique la informacion ingresada.",
            type: "error",
            confirmButtonColor: "#127570"
          });
        }

        return throwError(err);
      })
    );
  }

  public putUsuario(usuario): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_USUARIO;
    return this.http.put<any>(url, usuario).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Usuario",
            text: "Error actualizando información del usuario.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public deleteUsuario(usuario): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_USUARIO + "/" + usuario;
    return this.http.delete<any>(url).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Usuario",
            text: "Error eliminado información del usuario.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public getUsuariosPersonas(tipoUsuario, idUsuario, agencia): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_USUARIO +
      "/" +
      tipoUsuario +
      "/" +
      idUsuario +
      "/" +
      agencia;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Usuario",
            text: "Error Cargando Usuarios.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }
}
